import React from "react";
import withStyles from '@mui/styles/withStyles';
import iconBlueClose from "../../assets/images/icon_blue_close.svg";
import KyteTecError from "../../assets/images/error-kyte-tec-state.svg"
import useMakeScrollable from "../../custom_hooks/make-scrollable";

const topOffset = "10%";
const button = {
  boxShadow: "0px 3px 20px #00000026",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "uppercase",
  padding: "16px 30px",
  color: "#FFFFFF",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
};
const block = {
  padding: "0px 10px 0px 10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  root: {
    background: "white",
    minHeight: "100vh",
    overflowY: "auto",
  },
  kyteTecRegistration: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    background: "linear-gradient(#4396e6, #7CD1EA)",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    overflowY: "auto",
    marginBottom: "100px",
  },
  whiteText: {
    color: "white",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontWeight: "light",
    fontSize: "25px",
    width: "100%"
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
    filter:
      "invert(100%) sepia(84%) saturate(2%) hue-rotate(149deg) brightness(103%) contrast(101%)",
  },
  wrapper: {
    padding: "28px 0px 0px 0px",
  },
  block: block,
  blockWithDelimiter: {
    ...block,
    borderBottom: "1px solid #70707052",
  },
  buttonDanger: {
    ...button,
    backgroundColor: "#ffab9d",
  },
  buttonInfo: {
    ...button,
    backgroundColor: "white",
    color: "#4396e6",
  },
});

function KyteTecRegistrationModal({
  setShowPurchaseModal,
  setShowKyteTecEmailModal,
  setShowKyteTecInfoModal,
  setShowKyteTecRegistrationModal,
  couponCode,
  currentUser,
  discount,
  classes,
}) {
  useMakeScrollable('.scrollable-modal')
  const register = () => {
    setShowKyteTecRegistrationModal(false)
    setShowKyteTecEmailModal(true);
  };

  const openInfo = () => {
    setShowKyteTecInfoModal(true);
  };

  const closeModal = () => {
    setShowPurchaseModal(false)
    setShowKyteTecRegistrationModal(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.kyteTecRegistration}>
      <div className="scrollable-modal" style={{height: "100vh"}}>
          <div style={{ position: "relative" }} className={classes.block}>
            <img
              className={classes.closeIcon}
              src={iconBlueClose}
              alt="Close purchase modal"
              onClick={closeModal}
            />
            <div>
              <div className={classes.whiteText}>
                <div>
                  <p style={{overflow: 'visible'}}>
                    Upppsss.<br/> Deine Apotheke <br/> ist nicht <br/> für das KYTE-TEC <br/>
                    Apotheken-Couponing <br/> registriert.
                  </p>
                </div>
                <div>
                  <img alt="error" src={KyteTecError} />
                </div>
                <div className={classes.whiteText}>
                  <p>Was möchstest du tun?</p>
                </div>
              </div>
              <div style={{marginTop: "50px"}}>
                <div
                  style={{
                    margin: "5px 0px 10px 0px",
                    width: "80%",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={classes.buttonDanger}
                    style={{ alignItems: "center" }}
                    onClick={openInfo}
                  >
                    Infos
                  </div>
                </div>
                <div
                  style={{
                    margin: "20px 0px 20px 0px",
                    width: "80%",
                  }}
                >
                  <div className={classes.buttonDanger} onClick={register}>
                    <span>Anmelden</span>
                  </div>
                </div>
                <div
                  style={{
                    margin: "20px 0px 220px 0px",
                    width: "80%",
                  }}
                >
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    </div>
  );
}
export default withStyles(styles)(KyteTecRegistrationModal);
